import { View } from "react-native";
import React, { useEffect, useMemo } from "react";
import { RouteProp, useRoute } from "@react-navigation/native";
import { ScheduleStackParamList } from "navigation/types";
import { toScehdule, toSeatSelection } from "utils/navigationUtils";
import { useAccount } from "hooks/useAccount";
import { useFetchEventAvailablitiesQuery } from "queries/ticket.queries";
import MainContainer from "components/MainContainer";
import EventBanner from "components/EventBanner";
import { convertEventAvailabilityDetails } from "./helpers";
import { Card, Text } from "@ui-kitten/components";
import Button from "components/Button";
import { useAppDispatch } from "hooks/useAppDispatch";
import {
  setSelectedEvent,
  setSelectedSubscription,
} from "features/slices/reservationFlowSlice";
import { EventAvailabilityDetails } from "features/types";
import { getUniqSubscriptions } from "utils/subscriptionUtils";
import { formatEventDate } from "utils/eventUtils";

// This page is used in the pablo center environment for now,
// assuming only one active subscription per account
const EventAvailablityDetails = () => {
  const dispatch = useAppDispatch();

  const {
    params: { eventName },
  } = useRoute<RouteProp<ScheduleStackParamList, "EventAvailablityDetails">>();

  const { account } = useAccount();
  const uniqSubscriptions = getUniqSubscriptions(account?.subscriptions || []);

  const { data: eventAvailablities, refetch: fetchEventAvailablities } =
    useFetchEventAvailablitiesQuery({
      accountId: account?.id,
      planPackageId: uniqSubscriptions[0]?.planPackage.id,
    });

  const filteredEventAvailablities = useMemo(() => {
    if (!eventAvailablities) return [];
    return eventAvailablities.filter((event) => event.eventName === eventName);
  }, [eventAvailablities]);

  useEffect(() => {
    if (!eventName) {
      toScehdule();
    }
  }, [eventName]);

  useEffect(() => {
    if (!account) return;
    fetchEventAvailablities();
  }, [account]);

  const eventAvailablity = filteredEventAvailablities[0];

  const handleReserveClick = (e: EventAvailabilityDetails) => {
    dispatch(setSelectedSubscription(uniqSubscriptions[0]));
    dispatch(setSelectedEvent(e));
    toSeatSelection();
  };

  if (!eventAvailablities || !uniqSubscriptions)
    return (
      <View>
        <Text>Loading...</Text>
      </View>
    );

  if (filteredEventAvailablities.length === 0) {
    return (
      <MainContainer goBackAction={toScehdule}>
        <View className="p-4">
          <Text>No events available</Text>
        </View>
      </MainContainer>
    );
  }
  return (
    <MainContainer goBackAction={toScehdule}>
      <View className="p-4">
        {eventAvailablity && (
          <EventBanner
            event={convertEventAvailabilityDetails(eventAvailablity)}
            type="EVENT_AVAILABILITY "
          />
        )}
        <View className="mt-2 flex flex-row flex-wrap gap-y-2">
          {filteredEventAvailablities.map((event) => {
            return (
              <Card
                key={event.eventId}
                footer={
                  <View>
                    <Button
                      appearance="ghost"
                      onPress={() => handleReserveClick(event)}
                    >
                      Reserve
                    </Button>
                  </View>
                }
              >
                <Text>{event.eventName}</Text>
                <Text category="s1">{formatEventDate(event)}</Text>
              </Card>
            );
          })}
        </View>
      </View>
    </MainContainer>
  );
};

export default EventAvailablityDetails;
